<template>
    <div>
        <ul class="newsContainer">
            <li class="newsItem" v-for="(newItem, idx) in newList" :key="idx" @click="jumpUrl(newItem.url)">
                <template v-if="newItem.text">
                    <div class="topContext">
                        <img class="image" :src="newItem.img">
                        <p class="text">{{ newItem.text }}</p>
                    </div>

                    <div class="time">
                        <img :src="timeIcon" />
                        {{ newItem.time }}
                    </div>
                </template>
                <div v-else class="topContext"></div>
            </li>
        </ul>
    </div>

</template>

<script>
import timeIcon from "@/assets/img/jinju-2024/icon/icon_time@2x.png"
import msgCarouselImage0 from "@/assets/img/jinju-2024/msg_carousel_0.png"
import msgCarouselImage1 from "@/assets/img/jinju-2024/msg_carousel_1.jpg"
import msgCarouselImage2 from "@/assets/img/jinju-2024/msg_carousel_2.jpg"
import msgCarouselImage3 from "@/assets/img/jinju-2024/msg_carousel_3.jpg"
import msgCarouselImage4 from "@/assets/img/jinju-2024/msg_carousel_4.jpg"

export default {
    data() {
        return {
            timeIcon,
            newList: [
                { img: msgCarouselImage1, url: "https://www.time-weekly.com/post/312498", text: "粤省情重磅发布《2024广东企业新质生产力发展调研报告》:广东上市公司新质生产力综合表现30强出炉", time: "5分钟前" },
                { img: msgCarouselImage2, url: "https://www.time-weekly.com/post/312487", text: "独家专访李君如：发展新质生产力关键在人才，教育机制仍需改革", time: "5分钟前" },
                { img: msgCarouselImage3, url: "https://www.time-weekly.com/post/312439", text: "专访粤开证券首席经济学家罗志恒：科技创新是新质生产力的基础，要重塑激励机制", time: "5分钟前" },
                { img: msgCarouselImage4, url: "https://www.time-weekly.com/post/312434", text: "专访吕本富：新空间带来新财富，新质生产力更需要“生人合一”", time: "5分钟前" },
                { img: msgCarouselImage0, url: "https://www.time-weekly.com/post/312337", text: "广东省工商联副主席王福亮：民营企业要掌握发展主动权，发展新质生产力", time: "5分钟前" },
                { img: msgCarouselImage0, url: "https://www.time-weekly.com/post/312333", text: "大咖云集！李君如、黄奇帆、徐伟新等将莅临“新金融、新智造、新动能——新质生产力赋能高质量发展”论坛", time: "5分钟前" },
                { img: msgCarouselImage0, url: "https://www.time-weekly.com/post/312345", text: "新质生产力赋能高质量发展论坛开幕在即：大咖齐聚，共话新金融、新智造、新动能", time: "5分钟前" },
                { text: "" },

            ],
        }
    },
    methods: {
        jumpUrl(url) {
            if (url) {
                window.open(url, "_blank");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.newsContainer {
    display: flex;
    justify-content: space-between;

    flex-wrap: wrap;

    .newsItem {
        cursor: pointer;
        width: calc((100% - 69px) / 4);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 30px;

        .topContext {
            margin-bottom: 20px;

            .image {
                margin-bottom: 15px;
                width: 233px;
                height: 140px;
                object-fit: cover;
                object-position: top;
            }

            .text {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 24px;
            }
        }

        .time {
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 14px;
            color: #B7C2D0;
            line-height: 22px;
            display: flex;
            align-items: center;

            img {
                width: 18px;
                height: 18px;
                margin-right: 8px;
            }
        }
    }
}
</style>
